"use client";
import * as m from "motion/react-m";
import { useTranslations } from "next-intl";
import { useState } from "react";

import { SoundWave } from "../Icons/Icons";

export interface ConvAiOrbReadyProps {
  agentId: string;
  onStartCall: () => void;
  voiceId?: string;
}

export function ConvAiOrbReady({ voiceId: _voiceId, agentId: _agentId, onStartCall }: ConvAiOrbReadyProps) {
  const t = useTranslations("ClientKeys.ConvAI");
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      className='f-ui-03 absolute flex h-48 items-center rounded-full bg-default px-8 shadow-lg outline-2 outline-offset-4 outline-inverse transition-transform duration-200 hover:scale-105 focus-visible:outline'
      onClick={onStartCall}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span className='group flex h-32 w-32 scale-100 items-center justify-center rounded-full bg-inverse transition-transform duration-300'>
        <SoundWave className='absolute opacity-100 transition-opacity duration-300' />
      </span>
      <m.span animate={{ width: isHovered ? "auto" : 0 }} className='overflow-hidden whitespace-nowrap'>
        <span className='px-8'>{t("try_a_call")}</span>
      </m.span>
    </button>
  );
}
